<template>
  <base-section
    id="student-activities-22"
  >
    <base-section-heading
      title="Student Activities at ETS'22"
    />
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="8"
          offset-md="2"
        >
          <tss-2022 />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          md="4"
          offset-md="2"
          sm="12"
        >
          <phd-contest />
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="12"
        >
          <phd-forum />
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in studentsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < studentsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>
<script>
  import PhdContest from './PhdContest.vue'
  import PhdForum from './PhdForum.vue'
  import Tss2022 from './Tss2022.vue'
  export default {
    components: { Tss2022, PhdContest, PhdForum },

    data: () => ({
      isMobile: false,
      studentsfooter: [
        {
          name: 'Student Activities at ETS23',
          url: 'student-activities-23',
        },
        {
          name: 'Best Student Presentation Award',
          url: 'bspa',
        },
        {
          name: 'PhD Forum',
          url: 'student-phd-forum',
        },
        {
          name: 'McCluskey Award',
          url: 'mccluskey',
        },
        {
          name: 'Test Spring School',
          url: 'tss',
        },
        {
          name: 'Student Activities at ETS22',
          url: 'student-activities-22',
        },
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
